var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup116481(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 146,
    viewBox: "0 0 146 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_1036)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 16,
    width: 98,
    height: 98,
    rx: 28,
    fill: "#37393F"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.7085 60.2212C54.7085 72.5529 65.4965 82.7507 70.2716 86.6605L70.2735 86.6621C70.9582 87.2227 71.3006 87.5031 71.811 87.6468C72.208 87.7586 72.7919 87.7586 73.1889 87.6468C73.6998 87.503 74.0431 87.2222 74.7291 86.6605C79.5042 82.7507 90.2917 72.5528 90.2917 60.2211C90.2917 55.5543 88.4174 51.0787 85.0808 47.7788C81.7442 44.4789 77.2189 42.625 72.5003 42.625C67.7816 42.625 63.2561 44.4788 59.9196 47.7788C56.583 51.0787 54.7085 55.5544 54.7085 60.2212Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_1036",
    x: 0,
    y: 0,
    width: 146,
    height: 146,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_1036"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_1036",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup116481);
export default __webpack_public_path__ + "static/media/Group 11648 (1).ce8a552a20d076814a729d9350e577aa.svg";
export { ForwardRef as ReactComponent };